// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 7.99805H6V10.002H8.00391V7.99805Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 11.998H6V14.002H8.00391V11.998Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 15.998H6V18.002H8.00391V15.998Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.44237 2H2V22H22V8.63795L16.4684 2H11V5.91339L7.44237 2ZM11 8.88661V20H4V4H6.55763L11 8.88661ZM15 7.99805H17.0039V10.002H15V7.99805ZM15 11.998H17.0039V14.002H15V11.998ZM17.0039 15.998V18.002H15V15.998H17.0039Z"}}]};

const TownFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'town-filled',
    ref,
    icon: element,
  },
));

TownFilledIcon.displayName = 'TownFilledIcon';

export default TownFilledIcon;
